export const PartnerKey = {
  HEALTHJOY: 'HealthJoy',
  HEALTHGRADES: 'Healthgrades',
};
